import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-sm transition-colors hover:bg-gray-50" }
const _hoisted_2 = { class: "py-0.5 pl-6 pr-2" }
const _hoisted_3 = { class: "flex items-stretch gap-2" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "py-0.5 pr-2 tabular-nums" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 2,
  class: "text-[12px] font-medium text-gray-400"
}
const _hoisted_10 = { class: "py-0.5 pr-2 tabular-nums" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "py-0.5 pr-1 text-right tabular-nums" }
const _hoisted_13 = { class: "text-[11px] font-medium text-gray-400" }

import { computed } from 'vue';
import type { SectionObjectiveRow } from './objectiveRow';
import { objectiveValueColourClass, pigsToTargetColourClass, pigsToTargetTooltipKey, formatPigsToTarget } from './objectiveDisplay';
import { isInDeviation, isWithinTarget } from './deviation';
import { isBarOverflow } from './objectiveBar';
import ObjectiveBar from './ObjectiveBar.vue';

const placeholder = '—';


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionRow',
  props: {
    section: {},
    ceiling: {}
  },
  setup(__props: any) {

const props = __props;

const valueColourClass = computed(() => objectiveValueColourClass(props.section));

// See BarnRow.vue's own note on hasNoValue/nameTooltip - same rule, one level down.
const hasNoValue = computed(() => props.section.currentValue == null);
const nameTooltip = computed(() => (hasNoValue.value && props.section.status.message ? `${props.section.name} — ${props.section.status.message}` : props.section.name));

// Just the deviation-accent strip's colour - see BarnRow.vue's own note on the same computed.
const rowClasses = computed(() => {
    if (isInDeviation(props.section)) return 'border-l-red-400';
    if (isWithinTarget(props.section)) return 'border-l-green-400';
    return 'border-l-gray-100';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "w-0 border-l-2 border-gray-200",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["w-0 border-l-2", rowClasses.value]),
          "aria-hidden": "true"
        }, null, 2),
        _createElementVNode("span", {
          class: _normalizeClass(["min-w-0 flex-1 truncate text-[13px] font-medium", hasNoValue.value ? 'text-gray-400' : 'text-gray-700']),
          title: nameTooltip.value
        }, _toDisplayString(_ctx.section.name), 11, _hoisted_4)
      ])
    ]),
    _createElementVNode("td", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.section.currentValue != null && _ctx.section.resolvedTarget != null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(ObjectiveBar, {
                "current-value": _ctx.section.currentValue,
                "resolved-target": _ctx.section.resolvedTarget,
                "target-source": _ctx.section.status.target_source,
                ceiling: _ctx.ceiling,
                class: "w-16"
              }, null, 8, ["current-value", "resolved-target", "target-source", "ceiling"]),
              _createElementVNode("span", {
                class: _normalizeClass(["text-[12px] font-bold leading-none", valueColourClass.value])
              }, [
                _createTextVNode(_toDisplayString(_ctx.$n(_ctx.section.currentValue, 'decimal')) + "%", 1),
                (_unref(isBarOverflow)(_ctx.section.currentValue, _ctx.ceiling))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "»"))
                  : _createCommentVNode("", true)
              ], 2)
            ], 64))
          : (_ctx.section.currentValue != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-[13px] font-bold leading-none", valueColourClass.value]),
                  title: _ctx.section.status.message || undefined
                }, _toDisplayString(_ctx.$n(_ctx.section.currentValue, 'decimal')), 11, _hoisted_8),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-[11px] font-medium", valueColourClass.value])
                }, "%", 2)
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(placeholder)))
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
    _createElementVNode("td", _hoisted_10, [
      (_ctx.section.pigsToTarget != null)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["text-[10.5px] font-semibold", _unref(pigsToTargetColourClass)(_ctx.section.pigsToTarget)]),
            title: _unref(pigsToTargetTooltipKey)(_ctx.section.pigsToTarget) ? _ctx.$tc(`views.objectives.texts.${_unref(pigsToTargetTooltipKey)(_ctx.section.pigsToTarget)}`, Math.abs(_ctx.section.pigsToTarget)) : undefined
          }, _toDisplayString(_unref(formatPigsToTarget)(_ctx.section.pigsToTarget)), 11, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_12, [
      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('views.objectives.texts.deadCountLabel', { count: _ctx.section.deadCount })), 1)
    ])
  ]))
}
}

})